import { callGuestAPI } from "../axios/guestAxios";

async function getPaymentMethods() {
  const options = {
    method: "GET",
    url: "/reservation/v1/get-payment-methods",
  };
  const res = await callGuestAPI(options);
  return res;
}

async function createReservation(data) {
  const options = {
    method: "POST",
    url: "/reservation/v1/create-reservation",
    data,
  };
  const res = await callGuestAPI(options);
  return res;
}

const CheckoutServices = {
  getPaymentMethods,
  createReservation,
};

export default CheckoutServices;
